import ImageListItem from '../models/imageListItem';

var ImageList = Backbone.Collection.extend({ model: ImageListItem });

export default ImageList;
